import * as React from 'react';
import { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { ToastContainer } from 'react-toastify';

import ptBR from 'antd/locale/pt_BR';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Alert from 'components/Alert';
import { getRemoteThemeParam } from 'v2/helpers/remoteTheme';

import { ThemeProvider } from '@eduzz/ui-antd-theme';

const intlFormats = {
  number: {
    BRL: {
      style: 'currency' as const,
      currency: 'BRL'
    },
    USD: {
      style: 'currency' as const,
      currency: 'USD'
    }
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

type AppProvidersProps = {
  children: React.ReactNode;
};

function AppProviders({ children }: AppProvidersProps) {
  const [remoteTheme, setRemoteTheme] = useState(getRemoteThemeParam);

  useEffect(() => {
    const syncRemoteTheme = () => setRemoteTheme(getRemoteThemeParam());
    window.addEventListener('popstate', syncRemoteTheme);
    return () => window.removeEventListener('popstate', syncRemoteTheme);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <IntlProvider locale='pt-BR' formats={intlFormats} defaultFormats={intlFormats}>
        <ThemeProvider key={remoteTheme} locale={ptBR} enableAnimation>
          <Alert.Global />
          {children}
          <ToastContainer theme='colored' />
          <ReactQueryDevtools buttonPosition='bottom-right' />
        </ThemeProvider>
      </IntlProvider>
    </QueryClientProvider>
  );
}

export { AppProviders };
